// extracted by mini-css-extract-plugin
export default {"BackButton":"styles_BackButton__Q8zoR","label":"styles_label__XKdwh"};